export default "__VITE_ASSET__730a70db__"